import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;
interface IAreaCheckboxProps {
  $isChecked: boolean;
}
export const AreaCheckbox = styled.div<IAreaCheckboxProps>`
  position: absolute;
  top: 16px;
  right: 0;
  padding: 0 0.6rem 0 0;
  margin: 0;
  background-color: ${({ theme, $isChecked }) =>
    $isChecked ? theme.disabled : theme.white};
  z-index: 1;

  .MuiFormControlLabel-root {
    margin: 0;
  }

  .MuiCheckbox-root {
    padding: 0;
  }

  .MuiCheckbox-colorSecondary.Mui-checked {
    color: #fab01c;
  }
`;

